import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import CookiesConditionsTemplate from '@components/CookiesConditions/CookiesConditions';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import { IS_PROD } from '../constants';

interface ICookiesConditions {}

const CookiesConditions: NextPage<ICookiesConditions> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.page.common')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <CookiesConditionsTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default CookiesConditions;
